import { ProfileEducationTimeSubscription } from "modules/dashboard";
import { CountyFilterFields } from "./counties";
import { deadlineNotificationTypes } from "./deadlineTypes";
import { InfoType, infoTypes } from "./infoTypes";
import { NotificationType } from "./notification";
import { ProfessionalFieldFilterFields } from "./professionalFieldTypes";
import { RoleType } from "./userRoles";
import { MeasureFilterFields } from "./measureTypes";

export enum NotificationSubscriptionCategory {
    InfoTypeSubscription = "info-type",
    NotificationTypeSubscription = "notification-type",
    PlantProtectionCountySubscription = "plant-protection-county",
    NewsProfessionalFieldSubscription = "news-professional-field",
    ManifestationsCountySubscription = "manifestations-county",
    MainfestationsProfessionalFieldSubscription = "manifestations-professional-field",
    RecordsDeadlineSubscription = "records-deadline",
    EducationsCountiesSubscription = "educations-counties",
    EducationsProfessionalFieldSubscription = "educations-professional-field",
    EducationsInterventionsSubscription = "educations-interventions",
}

export type Subscription = {
    id: number;
    category: NotificationSubscriptionCategory;
    title: string;
    roles?: Array<RoleType>;
};

export type SubscriptionSection = {
    subscriptions: Array<Subscription>;
    groupTitle?: string;
    subgroups?: SubscriptionSection[];
    roles?: Array<RoleType>;
    customComponent?: React.ComponentType;
};

export interface TimeSubscription {
    startDate: Date | null;
    endDate: Date | null;
    isEnabled?: boolean;
}

export const NotificationSettingsSection = [
    {
        subscriptions: [
            {
                id: NotificationType.Email,
                category: NotificationSubscriptionCategory.NotificationTypeSubscription,
                title: "Email (primarno)",
            },
            {
                id: NotificationType.App,
                category: NotificationSubscriptionCategory.NotificationTypeSubscription,
                title: "Aplikacija",
            },
        ],
    },
] as Array<SubscriptionSection>;

export const NotificationSubscriptionsSection = [
    {
        subscriptions: [
            {
                id: InfoType.WeatherAlarm,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: infoTypes.WeatherAlarm.label,
            },
        ],
    },
    {
        subscriptions: [
            {
                id: InfoType.News,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: infoTypes.News.label,
            },
            {
                id: InfoType.Advice,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: infoTypes.Advice.label,
            },
        ],
        groupTitle: "Vijesti i savjeti",
        subgroups: [
            {
                subscriptions: Object.values(ProfessionalFieldFilterFields).map(field => ({
                    id: field.value,
                    category: NotificationSubscriptionCategory.NewsProfessionalFieldSubscription,
                    title: field.label,
                })),

                groupTitle: "Stručna područja",
            },
        ],
    },
    {
        subscriptions: [
            {
                id: InfoType.WineGrowing,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: "Vinogradarstvo",
            },
            {
                id: InfoType.FruitAndOliveGrowing,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: "Voćarstvo i maslinarstvo",
            },
            {
                id: InfoType.FarmingAndOther,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: "Ratarstvo i ostalo",
            },
        ],
        groupTitle: "Preporuke za zaštitu bilja",
        subgroups: [
            {
                subscriptions: Object.values(CountyFilterFields).map(county => ({
                    id: county.value,
                    category: NotificationSubscriptionCategory.PlantProtectionCountySubscription,
                    title: county.label,
                })),

                groupTitle: "Županije",
            },
        ],
    },
    {
        subscriptions: [
            {
                id: InfoType.Manifestations,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: "Manifestacije",
            },
        ],
        groupTitle: "Manifestacije",
        subgroups: [
            {
                subscriptions: Object.values(CountyFilterFields).map(county => ({
                    id: county.value,
                    category: NotificationSubscriptionCategory.ManifestationsCountySubscription,
                    title: county.label,
                })),

                groupTitle: "Županije",
            },
            {
                subscriptions: Object.values(ProfessionalFieldFilterFields).map(field => ({
                    id: field.value,
                    category:
                        NotificationSubscriptionCategory.MainfestationsProfessionalFieldSubscription,
                    title: field.label,
                })),

                groupTitle: "Stručna područja",
            },
        ],
    },
    {
        groupTitle: "Evidencije i edukacije",
        subscriptions: [
            {
                id: InfoType.CoursesNotification,
                category: NotificationSubscriptionCategory.InfoTypeSubscription,
                title: infoTypes.CoursesNotification.label,
                roles: [RoleType.Farmer],
            },
        ],
        subgroups: [
            {
                subscriptions: Object.values(deadlineNotificationTypes).map(field => ({
                    id: field.value,
                    category: NotificationSubscriptionCategory.RecordsDeadlineSubscription,
                    title: field.label,
                })),

                groupTitle: "Upozorenje prije isteka roka za ispunjavanje evidencije",
            },
            {
                groupTitle: "Edukacije - Županije",
                subscriptions: Object.values(CountyFilterFields).map(field => ({
                    id: field.value,
                    category: NotificationSubscriptionCategory.EducationsCountiesSubscription,
                    title: field.label,
                })),
                roles: [RoleType.Farmer],
            },
            {
                groupTitle: "Edukacije - Intervencije",
                subscriptions: Object.values(MeasureFilterFields).map(field => ({
                    id: field.value,
                    category: NotificationSubscriptionCategory.EducationsInterventionsSubscription,
                    title: field.label,
                })),
                roles: [RoleType.Farmer],
            },            
            {
                groupTitle: "Edukacije - Stručna područja",
                subscriptions: Object.values(ProfessionalFieldFilterFields).map(field => ({
                    id: field.value,
                    category:
                        NotificationSubscriptionCategory.EducationsProfessionalFieldSubscription,
                    title: field.label,
                })),
                roles: [RoleType.Farmer],
            },
            {
                groupTitle: "Edukacije - Vremenski okvir predbilježbi",
                subscriptions: [],
                customComponent: ProfileEducationTimeSubscription,
                roles: [RoleType.Farmer],
            },
        ],
    },
] as Array<SubscriptionSection>;

export const recordsModuleSubscriptionCategories = [
    {
        groupTitle: "OBAVIJEST ISTEKA ROKA ISPUNJAVANJA",
        subscriptions: Object.values(deadlineNotificationTypes).map(field => ({
            id: field.value,
            category: NotificationSubscriptionCategory.RecordsDeadlineSubscription,
            title: field.label,
        })),
    },
] as Array<SubscriptionSection>;

export const educationModuleSubscriptionCategories = [
    {
        groupTitle: "Županije",
        subscriptions: Object.values(CountyFilterFields).map(field => ({
            id: field.value,
            category: NotificationSubscriptionCategory.EducationsCountiesSubscription,
            title: field.label,
        })),
    },
    {
        groupTitle: "Intervencije",
        subscriptions: Object.values(MeasureFilterFields).map(field => ({
            id: field.value,
            category: NotificationSubscriptionCategory.EducationsInterventionsSubscription,
            title: field.label,
        })),
    },
    {
        groupTitle: "Stručna područja",
        subscriptions: Object.values(ProfessionalFieldFilterFields).map(field => ({
            id: field.value,
            category: NotificationSubscriptionCategory.EducationsProfessionalFieldSubscription,
            title: field.label,
        })),
    },
] as Array<SubscriptionSection>;
